export function scrollLoop(fn, fnForward, fnBackward) {
  let lastScrollPosition = -1

  function loop() {
    if (typeof requestAnimationFrame === "undefined") {
      return
    }
    if (lastScrollPosition === window.pageYOffset) {
      requestAnimationFrame(() => {
        loop(fn)
      })
      return false
    } else {
      if (lastScrollPosition < window.pageYOffset) {
        if (typeof fnForward === "function") {
          fnForward()
        }
      } else {
        if (typeof fnBackward === "function") {
          fnBackward()
        }
      }
      lastScrollPosition = window.pageYOffset
    }
    fn()
    requestAnimationFrame(() => {
      loop(fn)
    })
  }

  loop(fn)
}
